/*eslint-disable */

import addPaperFromDio from './add-paper-from-dio';
import addPaperFromLocal from './add-paper-from-local';
import addPaperFromQuery from './add-paper-from-query';
import { bus } from '@/main';

export default {
  name: 'add-papers-popup',
  components: {
    'upload-paper-f-local' : addPaperFromLocal,
    'upload-paper-f-query' : addPaperFromQuery,
    'upload-paper-f-dio' : addPaperFromDio
  },
  props: [],
  data () {
    return {
      paper_upload_state:'local'
    }
  },
  computed: {

  },
  mounted () {
  },
  methods: {
    closeCreatePaperpilePopup(){
      bus.$emit('addPaperPopupStateBus', false);
      document.body.classList.remove('body_right_scroll_remove')
    },
  }
}